import { j as r } from "./jsx-runtime-944c88e2.js";
import { Icon as o } from "./icon.js";
import { Typography as i } from "./typography.js";
import { Button as s } from "./button.js";
import { useState as n, useEffect as m } from "react";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./Ripple-5a8cf54c.js";
function a() {
  const [e, t] = n(0);
  return m(() => {
    t(Date.now());
  }, []), /* @__PURE__ */ r.jsxs(i.P, { children: [
    "Error occurred at: ",
    new Intl.DateTimeFormat("en-US", { timeStyle: "medium" }).format(e)
  ] });
}
const c = "https://westbendmutual.service-now.com/sp?id=sc_cat_item&sys_id=906528a10a0a0bf000a85bc20dfb6541", _ = ({ refresh: e, serviceNowURL: t }) => /* @__PURE__ */ r.jsxs(
  "div",
  {
    style: {
      display: "flex",
      flexDirection: "column",
      textAlign: "center",
      minHeight: "max(60vh, 16em)",
      justifyContent: "center",
      width: "80%",
      margin: "auto"
    },
    children: [
      /* @__PURE__ */ r.jsx("div", { className: "error-small-screen-icon", children: /* @__PURE__ */ r.jsx(o, { icon: "message-exclamation", size: "8x" }) }),
      /* @__PURE__ */ r.jsx(i.H1, { style: { paddingTop: ".5em" }, children: "We're sorry! This isn't loading right now." }),
      /* @__PURE__ */ r.jsxs(i.H2, { style: { paddingTop: "1em" }, children: [
        "Please 'refresh' to try again or",
        " ",
        /* @__PURE__ */ r.jsx(
          "a",
          {
            className: "visited:bg-transparent primary-color",
            href: t || c,
            target: "_blank",
            rel: "noreferrer",
            children: "Create a Service Now Ticket"
          }
        )
      ] }),
      e && /* @__PURE__ */ r.jsx(s, { className: "error-refresh-button", onClick: e, children: "Refresh" }),
      /* @__PURE__ */ r.jsx(a, {})
    ]
  }
);
export {
  _ as Error
};
